module.exports = __webpack_public_path__ + "static/media/firebase-logo.86880319.png";